import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {ApiService} from '../API/api.service';
import {LocalStorageService} from '../Local-Storage/local-storage.service';
import {Router} from '@angular/router';
import {JwtTokenService} from '../JwtToken/jwt-token.service';

// TODO: Needs to be removed once we have more details on roles
const userPermissions = [{
  name: 'Admin',
  rights: ['All']
}, {
  name: 'User',
  rights: ['Add', 'Edit']
}, {
  name: 'Guest',
  rights: ['View']
}];

@Injectable({
  providedIn: 'root'
})
export class UserService {
  selectedController = localStorage.getItem('selectedController') || 2;
  selectedGroup = new BehaviorSubject(Number(this.selectedController));
  selectedGrpObservable = this.selectedGroup.asObservable();
  private getEmployeesRoles = new BehaviorSubject({});
  getEmployeesByRole = this.getEmployeesRoles.asObservable();

  constructor(public localStorageService: LocalStorageService,
              private router: Router,
              public apiService: ApiService,
              private jwtTokenService: JwtTokenService) {
  }

  getEmployeesByRoles(data: any) {
    this.getEmployeesRoles.next(data);
  }

  selectChangeHandler(data: any) {
    this.selectedGroup.next(data);
  }

  getSelectedRole() {
    return this.selectedGrpObservable;
  }

  getUserdetails(): any {
    return this.localStorageService.getUserdetails();
  }

  setUserdetails(userDetails: any) {
    this.localStorageService.setUserdetails(userDetails);
    this.jwtTokenService.setWebToken(userDetails.webToken);
  }

  destroyUserdetails() {
    this.localStorageService.destroyUserdetails();
    this.jwtTokenService.destroyWebToken();
  }

  // userRoles
  getUserRoleDetails(): any {
    return this.localStorageService.getRoleUserdetails();
  }

  setRoleUserdetails(roleUserDetails: any) {
    this.localStorageService.setRoleUserDetails(roleUserDetails);
  }

  destroyRoleUserdetails() {
    this.localStorageService.destroyRoleUserDetails();
  }

  adminLogin(body: any): Observable<any> {
    return this.apiService.post('user/loginuser', body);
  }

  forgotPswdCheckUsername(body: any): Observable<any> {
    // return this.apiService.post('user/fgtpassusernamecheck', body)
    return this.apiService.post('', body);
  }

  resetPassword(body: any): Observable<any> {
    return this.apiService.post('user/setforgotpassword', body);
  }

  updateTerms(body: any): Observable<any> {
    return this.apiService.post('User/updateTermsCondition', body);
  }

  checkPswdLink(body: any): Observable<any> {
    return this.apiService.post('ResetPasswordKey/checkLinkValidity', body);
  }

  resetPswdByLink(body: any): Observable<any> {
    return this.apiService.post('ResetPasswordKey/updatePswdByLink', body);
  }

  get userPermission(): { name: string, rights: Array<string> }{
    return userPermissions[0];
  }

  doesUserHaveActionOnTheGivenAction(action: string): boolean {
    return this.userPermission
    .rights
    .some(right => right === action) || this.userPermission.rights.some(right => right === 'All');
  }


}
